module.exports = __webpack_public_path__ + "static/media/0027_LES_ENSEIGNES_LA_CAVE_LETTRE_A_LETTRE.b8abf1d8.webp";